<template>
  <div
    id="SearchDetailModal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modelSingle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl" role="document">
      <!--begin::Form-->
      <form class="kt-form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{this.$route.meta.breadcrumb}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="kt-portlet__body">
              <div class="kt-section kt-section--first">
                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>รหัสตัวแทนจำหน่าย :</label>
                      <span class="form-control-plaintext">{{apAgentCode}}</span>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>ชื่อตัวแทนจำหน่าย :</label>
                      <span class="form-control-plaintext">{{apAgentName}}</span>
                    </div>
                  </div>
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label>ที่อยู่ :</label>
                      <span class="form-control-plaintext">{{apAdress}}</span>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>เขตการขาย :</label>
                      <span class="form-control-plaintext">{{apArea}}</span>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>จังหวัด :</label>
                      <span class="form-control-plaintext">{{apProvince}}</span>
                    </div>
                  </div>
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label>เบอร์โทร :</label>
                      <span class="form-control-plaintext">{{apTel}}</span>
                    </div>
                  </div>
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label>Email :</label>
                      <span class="form-control-plaintext">{{apEmail}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              <i class="la la-close"></i> ปิดหน้าต่าง
            </button>
          </div>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
export default {
  data: function() {
    return {
      apAgentCode: null,
      apAgentName: null,
      apAdress: null,
      apArea: null,
      apProvince: null,
      apTel: null,
      apEmail: null
    };
  },
  async mounted() {
    let self = this;
    let router = this.$router;

    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
    });
    axios
      .get("/Api/Agents/" + this.$route.params.id)
      .then(function(response) {
        if (response.status == 200) {
          self.apAgentCode = response.data.agentCodeSap;
          self.apAgentName = response.data.agentName;
          self.apAdress = response.data.address;
          self.apArea = response.data.department;
          self.apProvince = response.data.provinceName;
          self.apTel = response.data.tel;
          self.apEmail = response.data.email;
        } else {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่พบข้อมูลตัวแทนจำหน่ายที่คุณเลือก",
            "warning"
          );
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลตัวแทนจำหน่ายได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });
    $("#SearchDetailModal")
      .on("hidden.bs.modal", function() {
        // Set go back
        router.go(-1);
        //self.$parent.reloadDataTable(false);
      })
      .modal("show");
  }
};
</script>


// WEBPACK FOOTER //
// App/Components/Master/Approver/ApproverAgentInfo.vue